import React from "react";
import { Tooltip, Icon, useBreakpoints } from "@qgiv/core-react";
import { MoreInfoModal } from "../components/MoreInfoModal";

/**
 * @param {object} options - The options for the tooltip.
 * @param {string[]} options.iconClassName - The class names for the tooltip icon.
 * @param {string} [options.iconGlyph] - The glyph for the tooltip icon.
 * @param {string} options.message - The message to display in the tooltip.
 * @param {string} [options.mobileMessage] - The message to display in the tooltip on mobile devices.
 * @param {string} [options.placement] - The placement of the tooltip.
 * @param {string} [options.position] - The position of the tooltip.
 * @param {string} [options.tooltipClassName] - The class names for the tooltip.
 * @param {string} [options.iconType] - The type of the tooltip icon.
 * @param {string} [options.theme] - The theme of the tooltip.
 * @returns {React.JSX.Element} The tooltip component.
 */
const useTooltip = ({
    // TODO: we are going to add a default of -margin-left--10 so that the icon spacing is baked
    // into this rather than being set by the text which precedes it. This will allow for more
    // consistent spacing. Task https://qgiv.atlassian.net/browse/QG-38148 - SB
    iconClassName = [],
    iconGlyph = "question-circle-regular",
    message = "",
    // Used to render an element children rather than a string
    mobileMessage,
    placement = "right",
    position = "center",
    tooltipClassName = "-type--regular -font-family--font-theme",
    iconType = "FontAwesome",
    theme = "dark",
}) => {
    const { isSmallScreen } = useBreakpoints();

    return (
        <span>
            {isSmallScreen ? (
                <MoreInfoModal position={position}>
                    {mobileMessage || message}
                </MoreInfoModal>
            ) : (
                <Tooltip
                    placement={placement}
                    content={message}
                    theme={theme}
                    tooltipClassName={tooltipClassName}
                >
                    <Icon
                        className={iconClassName.join(" ")}
                        glyph={iconGlyph}
                        type={iconType}
                    />
                </Tooltip>
            )}
        </span>
    );
};

export default useTooltip;
